import React from 'react';
import { View, Pressable, ScrollView } from 'react-native';
import { Text } from '@/components/ui/text';

interface CompletionScreenProps {
  onComplete: () => Promise<void>;
  isAdvancing: boolean;
}

export function CompletionScreen({ onComplete, isAdvancing }: CompletionScreenProps) {
  return (
    <ScrollView
      className="flex-1"
      showsVerticalScrollIndicator={false}
      contentContainerStyle={{ flexGrow: 1, justifyContent: 'center', alignItems: 'center', paddingHorizontal: 24 }}
    >
      <View className="items-center mb-8">
        <Text className="text-3xl font-bold text-foreground mb-2">You're all set!</Text>
        <Text className="text-base text-muted-foreground text-center">
          You're ready to start exploring dishes near you.
        </Text>
      </View>

      <Pressable
        onPress={onComplete}
        disabled={isAdvancing}
        accessibilityLabel="Let's go!"
        className="bg-primary rounded-lg py-3 px-8"
        style={{ opacity: isAdvancing ? 0.5 : 1 }}
      >
        <Text className="text-primary-foreground text-base font-semibold text-center">
          {isAdvancing ? 'Finishing up...' : "Let's go!"}
        </Text>
      </Pressable>
    </ScrollView>
  );
}
